import React from 'react';
import { CookiesProvider } from 'react-cookie';
import { DOCS_BASE_URL } from '../../constants/urls';

import { useTranslation } from 'react-i18next';

export function ResourceCenterNavBar(): React.ReactElement {
  const { t } = useTranslation('containerInterface');
  const navItemClass =
    'hyperlink relative ml-2 hidden whitespace-nowrap p-2 font-medium md:inline-block';

  return (
    <CookiesProvider>
      <div className="relative top-0 z-[100] h-[48px] w-full max-w-full">
        <nav className="absolute top-0 flex h-[65px] w-full border-b border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-900 px-6 shadow-sm">
          <a
            href="/"
            className="flex items-center hover:opacity-75 ltr:mr-auto rtl:ml-auto"
          >
            <img
              aria-hidden="true"
              className="inline h-10 flex-shrink-0"
              src={`${process.env.PUBLIC_PATH}logo-large.svg`}
            />
          </a>
          <div className="my-auto mr-8 ml-auto">
            <a href={DOCS_BASE_URL} className={navItemClass}>
              {t('common:resources')}
            </a>
            <a href={'/'} className={navItemClass}>
              {t('homeDashboard')}
            </a>
          </div>
        </nav>
      </div>
    </CookiesProvider>
  );
}
